import { PlayerApi, Player } from './players';

export class LocalStoragePlayerApi implements PlayerApi {
  static #LOCAL_STORAGE_KEY = 'players';

  #players: Player[] = [];

  constructor(private localStorage = window.localStorage) {
    this.load();
  }
  async addPlayer(player: Player): Promise<void> {
    const existingPlayer = this.#players.find((p) => p.name === player.name);
    if (existingPlayer) {
      return;
    }
    this.#players.push(player);
    this.store();
  }
  async removePlayer(playerName: string): Promise<void> {
    this.#players = this.#players.filter((p) => p.name !== playerName);
    this.store();
  }

  async list(): Promise<Player[]> {
    return [...this.#players];
  }

  private load(): void {
    const data = this.localStorage.getItem(
      LocalStoragePlayerApi.#LOCAL_STORAGE_KEY
    );
    if (data == null) {
      return;
    }

    try {
      this.#players = JSON.parse(data);
    } catch {
      this.#players = [];
    }
  }

  private store(): void {
    this.localStorage.setItem(
      LocalStoragePlayerApi.#LOCAL_STORAGE_KEY,
      JSON.stringify(this.#players)
    );
  }
}
